module.exports = __webpack_public_path__ + "static/media/sifter.511c9dea.png";